<template>
  <div class="edit-password-wrapper">
    <el-form :model="userForm" :rules="rules" ref="userForm" label-width="100px" class="user-form">
      <el-form-item label="新密码" prop="newPassword">
        <el-input show-password v-model="userForm.newPassword"></el-input>
      </el-form-item>
      <el-form-item label="旧密码" prop="oldPassword">
        <el-input show-password v-model="userForm.oldPassword"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('userForm')" :loading="submiting">提交修改</el-button>
        <!-- <el-button @click="onFormCancel">取消</el-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      submiting: false,
      userForm: {
        newPassword: "",
        oldPassword: ""
      },
      rules: {
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 3, max: 10, message: "长度在 3 到 10 个字符", trigger: "blur" }
        ],
        oldPassword: [
          { required: true, message: "请输入旧密码", trigger: "blur" },
          { min: 3, max: 10, message: "长度在 3 到 10 个字符", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.submiting = true;
          this.$api
            .put(`/users/me/password/updating`, this.userForm)
            .then(res => {
              if (res.status === 201 || res.status === 204) {
                this.submiting = false;
                this.$emit("onSuccess");
                this.$message.success("修改成功");
              }
            })
            .catch(err => {
              this.submiting = false;
              console.log(err.response);
              this.$message.error(err.response.data.message);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onFormCancel(){
        this.$emit('cancel')
    },
  }
};
</script>

<style lang="scss" scped>
.edit-password-wrapper {
  box-sizing: border-box;
  width: 500px;
  padding: 20px 0;
  margin: 0 auto;
}
</style>